import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";
import {gsap} from "../../lib/gsap";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-full");

        if (this.header) {
            this.toggleMobileNav();
            this.vegetations = this.header.querySelectorAll('.vegetation');
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }
        const closeTrigger = document.querySelector(".nav-main-close");
        if (closeTrigger) {
            closeTrigger.addEventListener("click", () => {
                this.closeMobileNav();
            });
        }
        const overlay = document.querySelector('.overlay');
        if (overlay) {
            overlay.addEventListener("click", () => {
                this.closeMobileNav();
            });
        }
    }

    static openMobileNav() {
        document.body.classList.add("navs-open");
        document.body.classList.remove("navs-site-switch-open");
        document.body.classList.remove("aside-form-opened");
        this.vegetationOnOpen();
        this.groupeOnOpen();
        this.hotelOnOpen();
        GlobalVariables.lenis?.stop();
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        this.vegetationOnClose();
        GlobalVariables.lenis?.start();
    }

    static closeAllLev2() {
        if (window.innerWidth > 991) {
            GlobalVariables.lenis?.start();
        }
    }

    static restoreNav() {
        this.closeAllLev2();
        this.closeMobileNav();
    }

    static adjustNavBg(levelTwo) {
        if (window.innerWidth > 991) {
            const navBg = this.header.querySelector(".nav-main .nav-main-bg");
            gsap.to(navBg, {duration: 0.3, height: levelTwo.offsetHeight});
        }
    }

    static vegetationOnOpen(){
        this.timeline = gsap.timeline({
            onComplete: () => {
                this.vegetations.forEach((el, index) => {
                    this.positions[index] = {
                        xPercent: gsap.getProperty(el, "xPercent"),
                        yPercent: gsap.getProperty(el, "yPercent")
                    };
                    this.quickX[index] = gsap.quickTo(el, "xPercent", { duration: 0.3, ease: "power2.out" });
                    this.quickY[index] = gsap.quickTo(el, "yPercent", { duration: 0.3, ease: "power2.out" });
                });
                this.vegetationAnimation();
            }
        });
        this.positions = [];
        this.quickX = [];
        this.quickY = [];

        this.timeline.from(this.vegetations, {
            duration: 0.8,
            xPercent: (index, target) => target.dataset.xFrom || 100,
            ease: "power1.ease",
            stagger: 0.15
        });
    }

    static vegetationOnClose(){
        if( this.timeline ){
            this.timeline.revert();
        }
    }

    static vegetationAnimation(){

        const container = document.querySelector('.navs');
        container.addEventListener("mousemove", (event) => {
            if (this.positions.length === 0) return;
            const { left, top, width, height } = container.getBoundingClientRect();
            const relativeX = event.clientX - left;
            const relativeY = event.clientY - top;

            const xMove = (relativeX / width - 0.5) * 5; // Mouvement ajusté au conteneur
            const yMove = (relativeY / height - 0.5) * 2.5;

            this.vegetations.forEach((el, index) => {
                this.quickX[index](this.positions[index].xPercent + xMove * (1 + index * 0.05));
                this.quickY[index](this.positions[index].yPercent + yMove * (1 + index * 0.05));
            });
        });

        container.addEventListener("mouseleave", () => {
            if (this.positions.length === 0) return;

            this.vegetations.forEach((el, index) => {
                this.quickX[index](this.positions[index].xPercent);
                this.quickY[index](this.positions[index].yPercent);
            });
        });

    }

    static groupeOnOpen(){
        let thumbnail = document.querySelector('.navs .thumbnail');
        if( thumbnail ){

            let menu = document.querySelector('.nav-main-groupe-hotel');
            let menuItems = menu.querySelectorAll('a');
            let images = thumbnail.querySelectorAll('img');

            const container = document.querySelector('.navs');

            const quickX = gsap.quickTo(thumbnail, "x", { duration: 0.3, ease: "power2.out" });
            const quickY = gsap.quickTo(thumbnail, "y", { duration: 0.3, ease: "power2.out" });
            const quickRotate = gsap.quickTo(thumbnail, "rotation", { duration: 0.3, ease: "power2.out" });

            let lastX = 0, lastY = 0;

            container.addEventListener("mousemove", (event) => {
                const { left, top } = container.getBoundingClientRect(); // Position du parent
                const rect = thumbnail.getBoundingClientRect(); // Taille du follower
                const offsetX = rect.width / 2;
                const offsetY = rect.height / 2;

                // Calcul des positions relatives
                const relativeX = event.clientX - left - offsetX;
                const relativeY = event.clientY - top - offsetY;

                // Calcul de l'angle de rotation en fonction du déplacement
                const deltaX = relativeX - lastX;
                // const deltaY = relativeY - lastY;
                const angle = deltaX * 0.3; // Ajuste la sensibilité de l'inclinaison

                // Mise à jour des valeurs stockées
                lastX = relativeX;
                lastY = relativeY;

                // Appliquer les animations
                quickX(relativeX);
                quickY(relativeY);
                quickRotate(angle); // Appliquer l'inclinaison
            });

            menuItems.forEach( (item, i) => {
                item.addEventListener( 'mouseenter', () => {
                    thumbnail.classList.add('reveal');
                    images.forEach((img) => {
                        img.classList.remove('reveal');
                    });
                    images[i].classList.add('reveal');
                });
            });

            menu.addEventListener( 'mouseleave', () => {
                thumbnail.classList.remove('reveal');
            });

        }
    }

    static hotelOnOpen(){
        let follower = document.querySelector('.navs .nav-main-follower');
        if( follower ){

            const menus = document.querySelectorAll('.nav-main-hotel');

            const container = document.querySelector('.navs');

            const quickX = gsap.quickTo(follower, "x", { duration: 0.3, ease: "power2.out" });
            const quickY = gsap.quickTo(follower, "y", { duration: 0.3, ease: "power2.out" });
            const quickRotate = gsap.quickTo(follower, "rotation", { duration: 0.3, ease: "power2.out" });

            let lastX = 0, lastY = 0;

            menus.forEach( (menu) => {
                let menuItems = menu.querySelectorAll('a');

                menuItems.forEach( (item, i) => {
                    item.addEventListener( 'mouseenter', () => {
                        gsap.to(follower, {
                            scale: 1
                        });
                    });
                    item.addEventListener( 'mouseleave', () => {
                        gsap.to(follower, {
                            scale: 0
                        });
                    });
                });
            });


            container.addEventListener("mousemove", (event) => {
                const { left, top } = container.getBoundingClientRect(); // Position du parent
                const rect = follower.getBoundingClientRect(); // Taille du follower
                const offsetX = rect.width / 2;
                const offsetY = rect.height / 2;

                // Calcul des positions relatives
                const relativeX = event.clientX - left - offsetX;
                const relativeY = event.clientY - top - offsetY;

                // Calcul de l'angle de rotation en fonction du déplacement
                const deltaX = relativeX - lastX;
                // const deltaY = relativeY - lastY;
                const angle = deltaX * 0.9; // Ajuste la sensibilité de l'inclinaison

                // Mise à jour des valeurs stockées
                lastX = relativeX;
                lastY = relativeY;

                // Appliquer les animations
                quickX(relativeX);
                quickY(relativeY);
                quickRotate(angle); // Appliquer l'inclinaison
            });

        }
    }

    static resize() {
        this.restoreNav();
    }
}